/* FERI Custom JavaScript
   Muss VOR content_for_header geladen werden (capture-phase Listener). */

/* FIX: Mega-Menu Hover von unten.
   Horizons Toggle-Logik läuft auf mouseenter/mouseleave des .menu-list__list-item.
   Bei Annäherung von unten feuert pointerleave/mouseleave auf dem LI sofort nach
   dem Öffnen, weil relatedTarget in einem parallelen LI-Knoten liegt (Horizons
   overflow-list dupliziert Nav-Elemente). Robusterer Fix: beide Leave-Events
   blockieren, solange clientY noch im Header-Bereich liegt. Beim Wechsel zu einem
   anderen Menüpunkt schließt Horizons mouseenter-Handler das alte Menü. */
(function () {
  var _hdr = null;
  function hdrBottom() {
    if (!_hdr) _hdr = document.querySelector('header-component') || document.getElementById('header-component');
    return _hdr ? _hdr.getBoundingClientRect().bottom : 80;
  }
  ['mouseleave', 'pointerleave'].forEach(function (evtName) {
    document.addEventListener(evtName, function (e) {
      var li = e.target;
      if (!li.classList || !li.classList.contains('menu-list__list-item')) return;
      if (e.clientY < hdrBottom()) {
        e.stopImmediatePropagation();
      }
    }, true);
  });
})();
